<!-- 预警等级 条形图-->
<template>
    <div id="warnningLevel">
    </div>
</template>

<script>
    export default {
        mounted() {
            this.queryEnvWarningLevel()
        },
        methods: {
            queryEnvWarningLevel() {
                this.$api.queryEnvWarningLevel().then(res => {
                    if (res.code === 200) {
                        let list = res.data || []
                        this.renderChart(list)
                    }
                })
            },
            renderChart(list) {
                let myChart = this.$echarts.init(
                    document.getElementById("warnningLevel")
                );
                // 绘制图表
                myChart.setOption({
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "5%",
                        top: "3%",
                        containLabel: true
                    },
                    xAxis: {
                        type: "value",
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false,
                            textStyle: {
                                color: "red"
                            }
                        }
                    },
                    yAxis: {
                        type: "category",
                        data: list.map(item => item.typeName),
                        axisLabel: {
                            show: true,
                            textStyle: {
                                color: "#fff"
                            }
                        }
                    },
                    series: [{
                        name: "搜索引擎",
                        type: "bar",
                        stack: "总量",
                        label: {
                            show: true,
                            position: "insideRight",
                            formatter:function(val){
                                // console.log(val.dataIndex,'formatter',list)
                                let html=list[val.dataIndex].number+'('+list[val.dataIndex].typeProportion+'%)';
                                return html;
                            }
                        },
                        data: list.map(item => item.number),
                        itemStyle: {
                            //通常情况下：
                            normal: {
                                //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
                                color: function(params) {
                                    var colorList = [
                                        "#FF564F",
                                        "#FF7A40",
                                        "#DCA436",
                                        "#0092FF"
                                    ]; //每根柱子的颜色
                                    return colorList[params.dataIndex];
                                }
                            }
                        }
                    }]
                });
                //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
                window.addEventListener("resize", function() {
                    myChart.resize();
                });
            }
        }
    }
</script>